import { render } from "./Alerts.vue?vue&type=template&id=4a830f87&scoped=true&ts=true"
import script from "./Alerts.vue?vue&type=script&lang=ts"
export * from "./Alerts.vue?vue&type=script&lang=ts"

import "./Alerts.vue?vue&type=style&index=0&id=4a830f87&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a830f87"]])

export default __exports__